import type { Resource } from '../../';
export const general_collapse: Resource = {"default":"Collapse"};
